// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/root.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/root.tsx");
}
// REMIX HMR END

import { json } from "@remix-run/cloudflare";
import { Links, LiveReload, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData, useNavigation } from "@remix-run/react";
import { HoneypotProvider } from "remix-utils/honeypot/react";
import { syncDrupalPreviewRoutes } from "drupal-decoupled";
import { useEffect } from "react";
import stylesheetPreview from "~/preview.css";
import stylesheet from "~/tailwind.css";
import { getHoneypot } from "~/utils/honeypot.server";
import ConsentCookieBanner from "./components/ConsentCookieBanner";
import { tagManagerInit } from "./services/google-tag-manager";
export const links = () => [{
  rel: "stylesheet",
  href: stylesheetPreview
}, {
  rel: "apple-touch-icon",
  sizes: "180x180",
  href: "/favicon/apple-touch-icon.png"
}, {
  rel: "icon",
  type: "image/png",
  sizes: "32x32",
  href: "/favicon/favicon-32x32.png"
}, {
  rel: "icon",
  type: "image/png",
  sizes: "16x16",
  href: "/favicon/favicon-16x16.png"
}, {
  rel: "icon",
  type: "image/png",
  sizes: "192x192",
  href: "/favicon/android-chrome-192x192.png"
}, {
  rel: "icon",
  type: "image/png",
  sizes: "512x512",
  href: "/favicon/android-chrome-512x512.png"
}, {
  rel: "icon",
  type: "image/x-icon",
  href: "/favicon/favicon.ico"
}, {
  rel: "stylesheet",
  href: stylesheet
}, {
  rel: "preconnect",
  href: "https://fonts.googleapis.com"
}, {
  rel: "preconnect",
  href: "https://fonts.gstatic.com",
  crossOrigin: "anonymous"
}, {
  rel: "preload",
  as: "style",
  href: "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700&display=swap"
}];
export const loader = async ({
  context
}) => {
  const honeypot = getHoneypot(context.HONEYPOT_SEED);
  const honeypotInputProps = await honeypot.getInputProps();
  return json({
    environment: context.ENVIRONMENT,
    gtmId: context.ENVIRONMENT === "production" ? context.GTM_ID : undefined,
    honeypotInputProps
  });
};
export default function App() {
  _s();
  const {
    environment,
    gtmId,
    honeypotInputProps
  } = useLoaderData();
  const navigation = useNavigation();
  if (environment === "preview" && navigation.state === "loading") {
    syncDrupalPreviewRoutes(navigation.location.pathname);
  }
  useEffect(() => {
    if (environment === "production" && gtmId) {
      if (!("dataLayer" in window)) {
        tagManagerInit({
          gtmId
        });
      }
    }
  }, []);
  return <html lang="en">
      <head>
        <Meta />
        <Links />
      </head>
      <body className="min-h-screen flex flex-col bg-neutral-100">
        <HoneypotProvider {...honeypotInputProps}>
          <Outlet />
          <ConsentCookieBanner />
        </HoneypotProvider>
        <ScrollRestoration />
        <Scripts />
        <LiveReload />
      </body>
    </html>;
}
_s(App, "ydgQu4TnPLtlclRb7IxnYbgGxrQ=", false, function () {
  return [useLoaderData, useNavigation];
});
_c = App;
var _c;
$RefreshReg$(_c, "App");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;